import { render } from "./gmQuery.vue?vue&type=template&id=3ff8148b&scoped=true"
import script from "./gmQuery.vue?vue&type=script&lang=js"
export * from "./gmQuery.vue?vue&type=script&lang=js"

import "./gmQuery.vue?vue&type=style&index=0&id=3ff8148b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3ff8148b"

export default script